module.exports = "<p>\n<router-outlet></router-outlet>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/app/containers/admin/admin.component.html
// module id = ../../../../../src/app/containers/admin/admin.component.html
// module chunks = main